import { APP_INITIALIZER, LOCALE_ID, Provider } from '@angular/core';
import { I18nTranslateService } from '@app/core/services/i18n-translate.service';
import { I18NEXT_ERROR_HANDLING_STRATEGY } from 'angular-i18next';
import { InitOptions } from 'i18next';
import LanguageDetector, { DetectorOptions } from 'i18next-browser-languagedetector';
import XHR from 'i18next-http-backend';

const supportLanguages = ['en', 'zh'];

const defaultLanguage = 'en';

const defaultNamespaces = ['common', 'common_error'];

const detectOptions: DetectorOptions = {
  order: ['localStorage', 'cookie'],
  lookupLocalStorage: 'nb_i18n_lang',
};

const backendOptions: any = {
  loadPath: (lang, ns) => {
    return `locales/${lang}/${ns}.json`;
  },
};

export const i18nextOptions: InitOptions = {
  lng: defaultLanguage,
  fallbackLng: defaultLanguage,
  supportedLngs: supportLanguages,
  load: 'languageOnly',
  preload: [defaultLanguage],
  ns: defaultNamespaces,
  saveMissing: false,
  updateMissing: false,
  interpolation: {},
  detection: detectOptions,
  backend: backendOptions,
  debug: process.env.NODE_ENV !== 'production',
};

export function i18nFactory(i18nInstance: I18nTranslateService) {
  return () => {
    i18nInstance
      .use(XHR)
      .use(LanguageDetector)
      .init(i18nextOptions);
    return i18nInstance;
  };
}

export function localeFactory(i18nInstance: I18nTranslateService) {
  return i18nInstance.language;
}

export const I18nProviders: Provider[] = [
  {
    provide: I18nTranslateService,
    useClass: I18nTranslateService,
    deps: [I18NEXT_ERROR_HANDLING_STRATEGY],
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: i18nFactory,
    deps: [I18nTranslateService],
  },
  {
    provide: LOCALE_ID,
    useFactory: localeFactory,
    deps: [I18nTranslateService],
  },
];
